import fetch from '@/utils/fetch'

export const List = '/govsubsidy/setting/distributor/items'

// 设置国补设置说明
export function setgovSettingDesc(data) {
  return fetch({
    url: '/govsubsidy/setting/desc',
    method: 'post',
    data
  })
}

// 获取国补设置说明
export function getgovSettingDesc (query) {
  return fetch({
    url: 'govsubsidy/setting/desc',
    method: 'get',
    params: query
  })
}
// 设置顺丰微派编码
export function setWeiPai (data) {
  return fetch({
    url: 'subsidy/weipaiMerchants',
    method: 'post',
    data
  })
}

// 获取顺丰微派编码
export function getWeiPai (query) {
  return fetch({
    url: 'subsidy/weipaiMerchants',
    method: 'get',
    params: query
  })
}